
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/overview",
      function () {
        return require("private-next-pages/my-account/overview.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/overview"])
      });
    }
  